import { render, staticRenderFns } from "./PurchasePreventAlert.vue?vue&type=template&id=2f18e27d&scoped=true"
import script from "./PurchasePreventAlert.vue?vue&type=script&lang=js"
export * from "./PurchasePreventAlert.vue?vue&type=script&lang=js"
import style0 from "./PurchasePreventAlert.vue?vue&type=style&index=0&id=2f18e27d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18e27d",
  null
  
)

export default component.exports